require('jquery-migrate');
Promise.polyfill();
$.browser = { msie: true };
jQuery.migrateMute = true;

import * as Sentry from '@sentry/browser';
window.Sentry = Sentry;
